'use client';

export const BridgeEvent = {
  SetContext: 'set-context',
  InsightsTraceInformation: 'insights-trace-information',
  InsightsTraceWarning: 'insights-trace-warning',
  InsightsTraceError: 'insights-trace-error',
  InsightsTag: 'insights-tag',
  ReceiveData: 'receive-data',
  SendData: 'send-data',
  ShareFile: 'share-file',
  SetCustomerUserId: 'set-customer-user-id',
  HealthRequestPermissions: 'health-request-permissions',
  HealthFetchData: 'health-fetch-data',
  HealthGetStatus: 'health-get-status',
  HealthStatusUpdate: 'health-status-update',
  HealthDataReceived: 'health-data-received',
  HealthPermissionsResult: 'health-permissions-result',
  HealthError: 'health-error',
  HealthOpenSettings: 'health-open-settings',
  HealthOpenAppSettings: 'health-open-app-settings',
  HealthRevokePermissions: 'health-revoke-permissions',
  HealthDataUpdated: 'health-data-updated',
};

export const NativeBridgeAvailable =
  typeof window !== 'undefined' && !!window?.ReactNativeWebView;
